export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['banner/setState'](state, payload) {
            state.data = {...payload,}
        },
        ['banner/setPage'](state, payload) {
            state.data.page = payload;
        },
    },
    actions: {

    },
}
